import { createEntityAdapter } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'
import { Slot } from './Type'

export const bookableSlotsAdapter = createEntityAdapter<Slot>({
  selectId: (slot) => `${slot.date}T${slot.start_time}`,
  sortComparer: (a, b) => `${a.date}T${a.start_time}`.localeCompare(`${b.date}T${b.start_time}`),
})

export const { selectAll: selectBookableSlots } = bookableSlotsAdapter.getSelectors<RootState>(
  (state) => state.bookableSlots
)
